export default __webpack_public_path__ + "static/04_integrate-3943ed8263f0f72915529730450f27fd.mp4";